export default __webpack_public_path__ + "static/media/water-sink.60134167.svg";